"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;

var _utils = require("../../modules/utils");

var _mapper = _interopRequireDefault(require("./mapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getLocation(client) {
  return (0, _utils.getPublicRequest)(client).then(function (request) {
    return request.get(client.context.api.host + '/v3/location').then(function (res) {
      return (0, _mapper["default"])(res.body);
    })["catch"](_utils.rejectWithNormalizedErr);
  });
}